import React, { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Base, BaseElement, BaseProps, BasePropsList } from '../Base/index.js';

export type FlexElement = BaseElement;
export interface FlexProps extends BaseProps {
  /**
   * Flex direction property (column)
   */
  column?: boolean;
  /**
   * Flex direction property (row-reverse or column-reverse)
   */
  reverse?: boolean;
  /**
   * Display property (inline-flex)
   */
  inline?: boolean;
  /**
   * Grows to fill the available space
   */
  grow?: boolean | React.CSSProperties['flexGrow'];
}

export const FlexPropsList: Array<keyof FlexProps> = [
  ...BasePropsList,
  'column',
  'reverse',
  'inline',
  'grow',
];

export const formatFlexDirection = (column: boolean, reverse: boolean) => {
  let flexDirection = 'row';

  if (column) {
    flexDirection = 'column';
  }

  if (flexDirection && reverse) {
    flexDirection += '-reverse';
  }

  return flexDirection as React.CSSProperties['flexDirection'] | undefined;
};

export const Flex = styled(
  forwardRef<FlexElement, FlexProps>(
    (
      {
        column = false,
        reverse = false,
        inline = false,
        grow,
        display = inline ? 'inline-flex' : 'flex',
        ...restProps
      },
      ref
    ) => {
      return (
        <Base
          display={display}
          flexDirection={formatFlexDirection(column, reverse)}
          flexGrow={grow === true ? 1 : grow || undefined}
          {...restProps}
          ref={ref}
        />
      );
    }
  )
).withConfig({
  displayName: 'Flex',
})``;
